export default __webpack_public_path__ + "static/0-d6ec9d0eb04abe55da5338750174e481.png";